module.exports = global["$q"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$q!./cloud/lib/jquery.js
// module id = 2
// module chunks = 52